module.exports = __webpack_public_path__ + "ace00e014aa7f80217b6b2e0f0132212.svg";